// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__KX5Vv","tab":"Tabs_tab__ayZSY","tabActive":"Tabs_tabActive__a8Z1I","tabDisabled":"Tabs_tabDisabled__jjR9e"};